var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2114 43.4723C19.2325 42.9258 17.9534 41.7311 17.4855 39.6927C17.3935 39.2939 17.2861 38.8144 16.6437 38.7358C16.5153 38.8816 16.2583 39.0388 16.2142 39.2421C15.6964 41.6218 14.2467 43.0619 11.8995 43.643C11.5908 43.7197 11.3128 43.9287 11.4105 44.3084C11.5218 44.736 11.9302 44.8108 12.2888 44.9028C14.2908 45.4091 15.5258 46.6747 16.055 48.6575C16.1643 49.0679 16.2257 49.6029 16.7876 49.5818C17.336 49.5626 17.4108 49.0122 17.5105 48.6115C17.9938 46.6689 19.1961 45.4704 21.1176 44.9488C21.5222 44.8395 22.0649 44.7878 22.1128 44.247C22.1627 43.6659 21.6026 43.5797 21.2114 43.4723Z",
    fill: "url(#paint0_linear_2700_5258)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5045 15.4386C11.2227 16.384 13.6369 18.5988 14.4769 22.4262C14.5919 22.9516 14.7243 23.7282 15.4568 23.6841C16.1452 23.6438 16.2449 22.8979 16.3753 22.3514C17.2536 18.683 19.5125 16.4124 23.1715 15.5037C23.7142 15.3695 24.347 15.2698 24.5119 14.5526C24.3949 13.9754 23.9366 13.7817 23.438 13.6685C19.5645 12.7845 17.1902 10.4086 16.31 6.53318C16.1988 6.04419 16.0473 5.44012 15.4893 5.40178C14.7318 5.35192 14.6091 6.10172 14.4864 6.62905C13.6139 10.4106 11.3223 12.7364 7.53705 13.6284C7.02886 13.7473 6.27143 13.8164 6.36539 14.639C6.43635 15.2507 7.04044 15.3216 7.5045 15.4386Z",
    fill: "url(#paint1_linear_2700_5258)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0892 31.2361C15.1832 32.3924 16.5101 32.3445 17.3366 32.5478C24.0945 34.195 28.1882 38.4097 29.8396 45.1293C30.064 46.0402 29.9758 47.5551 31.3545 47.4899C32.67 47.4266 32.5453 45.927 32.7754 45.0008C34.4169 38.4005 38.4592 34.245 45.0865 32.6284C45.6924 32.4808 46.2984 32.289 46.8603 32.0224C47.1901 31.8652 47.4298 31.52 47.6388 31.3225C47.4087 30.2294 46.6665 30.0895 45.9647 29.9245C38.6663 28.193 34.07 23.796 32.5339 16.3553C32.3882 15.6535 32.2405 14.7368 31.3872 14.6812C30.2692 14.6084 30.1983 15.6918 30.0315 16.4569C28.4782 23.5712 24.1921 28.0164 17.1338 29.8131C16.2881 30.0279 14.9876 29.9782 15.0892 31.2361Z",
    fill: "url(#paint2_linear_2700_5258)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2700_5258",
    x1: 11.3906,
    y1: 44.1591,
    x2: 22.1159,
    y2: 44.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E9EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2700_5258",
    x1: 6.35742,
    y1: 14.5427,
    x2: 24.5119,
    y2: 14.5427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E9EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2700_5258",
    x1: 15.084,
    y1: 31.0848,
    x2: 47.6388,
    y2: 31.0848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E9EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSparkle);
export default __webpack_public_path__ + "static/media/star_sparkle.15155b2f728796145632836faadff50c.svg";
export { ForwardRef as ReactComponent };